import fetch from "../fetch";
import baseServ from "./baseServ";
export default {
	...baseServ,
	apis: {
		_login: "/web/live/login/login.am",
		_upLoadFile: "live/video/Courseware/uploadFile.am",
		_getCoursewareList:"/live/teacher/Courseware/getCoursewareList.am",
		_deleteCourseware:'/live/teacher/Courseware/deleteCourseware.am',
	},

	//用户登录
	login(username, password, loginUserType, code) {
		return fetch({
			url: this.apis._login,
			method: "post",
			data: {
				username,
				password,
				loginUserType,
				code,
			},
		});
	},
	upLoadFile(userId,upFile) {
		return fetch({
			url: this.apis._upLoadFile,
			method: "post",
			data: {
				userId,
				upFile,
				videoType:1,
			},
		});
	},
	getFileList(userId,fileType,fileName) {
		return fetch({
			url: this.apis._getCoursewareList,
			method: "post",
			data: {
				queryType:1,
				userId,
				fileType,
				fileName
			},
		});
	},
	deleteFile(userId,fileId) {
		return fetch({
			url: this.apis._deleteCourseware,
			method: "post",
			data: {
				userId,
				fileId
			},
		});
	},
};
